import React from 'react';
import NavBar from './NavBar';

const Header = () => (
  <div className="header">
    <h1 className="title-text">
      Math Magicians
    </h1>
    <NavBar />
  </div>
);

export default Header;
